import { Outlet } from "react-router-dom";

import { FilterTransactionProvider } from "./filter-transaction/filter-transaction.context";
import "./transaction.scss";
import { TransactionHelperProvider } from "./transaction-helper/transaction-helper.context";

export function Transaction() {
  return (
    <div id="ShellTransaction" className="transaction">
      <FilterTransactionProvider>
        <TransactionHelperProvider>
          <Outlet />
        </TransactionHelperProvider>
      </FilterTransactionProvider>
    </div>
  );
}

export default Transaction;
